class ThirdsApi {
    checkStatus(response) {
        switch (response.status) {
            case 500: //Error 500 del Servidor
                throw new Error(`${response.status} - Server Error!`);
                break;
            default:
                break;
        }
    }

    //Listar Patrocniadores y terceros Normales
    async listThirdsReports() {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}tercero/listar-terceros-indicadores`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

    //Busca los CONTRATOS (Planes)
    getContracts = async (thirdId) => {
        let datos;
        var data = { id: thirdId };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        }).then(response => {
            return response.json();
        }).then(data => {
            console.log("PlanesTercero", data);
            if (data.existe) {
                datos = data.contenido;
            } else {
                datos = [];
            }
        }).catch((error) => {
            datos = [];
            console.error('Error:', error);
        });
        return datos;
    }

    //Lista los terceros con el contrato
    loadThirdPlusContract = async () => {
        let datos;
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/listar-terceros', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error(response.json());
            }
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

}



export default new ThirdsApi();